"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkResponse = exports.buildOptions = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _servicehttpresponseerror = _interopRequireDefault(require("../errors/servicehttpresponseerror"));

var _httpmethods = _interopRequireDefault(require("./httpmethods"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CONTENT_TYPE = "content-type";
var APPLICATION_JSON = "application/json";
var CORS = "cors";

var buildOptions = function buildOptions(_ref) {
  var accessToken = _ref.accessToken,
      _ref$method = _ref.method,
      method = _ref$method === void 0 ? "GET" : _ref$method,
      body = _ref.body,
      additionalHeaders = _ref.additionalHeaders;

  var headers = _objectSpread({
    Accept: APPLICATION_JSON,
    Authorization: "Bearer ".concat(accessToken)
  }, additionalHeaders);

  if (method === _httpmethods["default"].POST || method === _httpmethods["default"].PUT || method === _httpmethods["default"].PATCH) {
    headers[CONTENT_TYPE] = APPLICATION_JSON;
  }

  if (body && typeof body !== "string") {
    // eslint-disable-next-line no-param-reassign
    body = JSON.stringify(body);
  }

  return {
    method: method,
    mode: CORS,
    headers: headers,
    body: body
  };
};

exports.buildOptions = buildOptions;

var checkResponse = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(res, serviceComment, isSimpleResponse) {
    var body, response, err;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!res.ok) {
              _context.next = 7;
              break;
            }

            if (!(res.status === 204)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", isSimpleResponse ? null : {
              response: res
            });

          case 3:
            _context.next = 5;
            return res.json();

          case 5:
            body = _context.sent;
            return _context.abrupt("return", isSimpleResponse ? body : {
              response: res,
              body: body
            });

          case 7:
            response = {
              status: res.status,
              statusText: res.statusText,
              ok: res.ok
            };
            _context.next = 10;
            return /application\/json/.test(res.headers.get(CONTENT_TYPE)) ? res.json() : res.text();

          case 10:
            response.body = _context.sent;
            err = new _servicehttpresponseerror["default"]("Error fetching ".concat(serviceComment), response);

            if (window.newrelic) {
              window.newrelic.noticeError(err);
            }

            throw err;

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function checkResponse(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

exports.checkResponse = checkResponse;